export default __webpack_public_path__ + "img/44bc295dcac1bb3989fb0b6967c4b9b3.svg";